import React, {Component} from 'react';
import {Container, Grid, Header, Segment} from 'semantic-ui-react';
import SolarRadianceChartContainer from "../../containers/SolarRadianceChartContainer";
import PowerOutputChartContainer from "../../containers/PowerOutputChartContainer";
import EnergyStorageChartContainer from "../../containers/EnergyStorageChartContainer";
import LatestEventsFeedContainer from "../../containers/LatestEventsFeedContainer";
import PanelStatusTableContainer from "../../containers/PanelStatusTableContainer";
import './OverviewPageContent.css';

class OverviewPageContent extends Component {
  render() {
    return (
      <Container>
        <Header as='h1' content='Dahsboard del Sistema' subheader='Bienvenido al estado de tu sistema de paneles solar de Asterion Energy'/>
        <Grid stackable stretched>
          <Grid.Column computer={8} largeScreen={4} widescreen={4}>
            <Segment>
              <Header icon='sun' content='Radiación Solar'/>
              <p>Radiación Solar en cada panel</p>
              <SolarRadianceChartContainer/>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={8} largeScreen={4} widescreen={4}>
            <Segment>
              <Header icon='tachometer alternate' content='Potencia de salida'/>
              <p>Energía solar maximizada de salida</p>
              <PowerOutputChartContainer/>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={8} largeScreen={4} widescreen={4}>
            <Segment>
              <Header icon='battery three quarters' content='Energy Storage'/>
              <p>Energía almacenada en cada batería</p>
              <EnergyStorageChartContainer/>
            </Segment>
          </Grid.Column>
          <Grid.Column computer={8} largeScreen={4} widescreen={4}>
            <Segment>
              <Header icon='clock' content='Últimas Actualizaciones'/>
              <p>Últimas actualizaciones del sistema</p>
              <LatestEventsFeedContainer/>
            </Segment>
          </Grid.Column>
          <Grid.Column width={16}>
            <Segment>
              <Header icon='sliders horizontal' content='Estatus del Panel'/>
              <p>Estatus de cada panel solar</p>
              <PanelStatusTableContainer/>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default OverviewPageContent;



// WEBPACK FOOTER //
// ./src/components/OverviewPageContent/OverviewPageContent.js